import { useQuery } from "@tanstack/react-query";
import instance from "services/axiosServices";
import leadsWebEnviroment from "../../../utils/leadsWebEnviroment";

export function useListarPrazosEntregasImovel() {
  const fetchData = async () => {
    const LISTAR_PRAZOS_ENTREGA_IMOVEL = `${leadsWebEnviroment}/mobile/prazos-entrega-imovel/v1`;
    const response = await instance.get(LISTAR_PRAZOS_ENTREGA_IMOVEL);
    const dataWithPagination = {
      data: response?.data?.data,
      pagination: response?.data?.pagination,
    };
    return dataWithPagination;
  };
  const query = useQuery({
    queryFn: () => fetchData(),
    refetchOnWindowFocus: false,
    queryKey: ["listar_prazos_entregas_imovel"],
    refetchOnMount: false,
  });
  return query;
}
